// ModalVideo.jsx
import React, { useEffect } from "react";
import styles from "../css/ModalVideo.module.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function ModalVideo({
  show,
  videos,
  currentIndex,
  onClose,
  setCurrentIndex,
  currentTitle,
  hideSubtitles = false,
}) {
  // keep hooks unconditionally
  useEffect(() => {
    if (!show) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [show]);

  if (!show) return null;

  const currentVideo = videos[currentIndex];
  const showChevrons = videos.length > 1;

  return (
    <div
      className={styles.modalOverlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className={styles.videoPopup}>
        {/* plain white × (your original style) */}
        <div className={styles.videoCloseButton} onClick={onClose}>
          &times;
        </div>

        {!hideSubtitles && (
          <div className={styles.videoHeader}>
            {!hideSubtitles && (
              <>
                {currentVideo.source === "default" && (
                  <div className={styles.defaultSubtitleBox}>
                    No community unlocks yet! Be the first!
                  </div>
                )}

                {currentVideo.source === "unlocked" && (
                  <p className={styles.videoSubtitle}>
                    Unlocks from our community!
                  </p>
                )}

                {/* Community progress (keep old behavior) */}
                {currentVideo.source !== "default" &&
                  currentVideo.source !== "unlocked" &&
                  currentVideo.source !== "personal" && (
                    <p className={styles.progressSubtitle}>
                      Progress from our community:
                    </p>
                  )}

                {/* ✅ Personal (second column) – show username or nothing */}
                {currentVideo.source === "personal" && currentVideo.username && (
                  <p
                    className={
                      currentVideo.status === "unlocked"
                        ? styles.videoSubtitle      // green pill (same as community "unlocked")
                        : styles.progressSubtitle   // yellow pill (same as "progress from our community")
                    }
                  >
                    {currentVideo.username}
                  </p>
                )}
              </>
            )}

            <h2 className={styles.videoTitle}>{currentTitle}</h2>
          </div>
        )}

        <div className={styles.carouselContainer}>
          {showChevrons && (
            <button
              onClick={() =>
                setCurrentIndex(
                  (prev) => (prev - 1 + videos.length) % videos.length
                )
              }
              className={styles.chevronButton}
              aria-label="Previous"
            >
              <FaChevronLeft />
            </button>
          )}

          {/* no pill; just the media */}
          {currentVideo.kind === "youtube" ? (
            <iframe
              key={currentVideo.url}
              src={currentVideo.url}
              title="Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          ) : (
            <video
              key={currentVideo.url}
              src={currentVideo.url}
              controls
              playsInline
            />
          )}

          {showChevrons && (
            <button
              onClick={() =>
                setCurrentIndex((prev) => (prev + 1) % videos.length)
              }
              className={styles.chevronButton}
              aria-label="Next"
            >
              <FaChevronRight />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ModalVideo;
